export type TrajectoryData = {
  messages: {
    role: string;
    content: string | null;
    tool_calls:
      | {
          function: {
            name: string;
            arguments: string;
          } | null;
        }[]
      | null;
    trainable?: boolean;
  }[];
  tools: string | null;
};

const roleStyles = {
  user: "bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 self-start",
  assistant:
    "bg-teal-100 dark:bg-teal-900 text-teal-800 dark:text-teal-200 self-end",
  tool: "bg-orange-100 dark:bg-orange-900 text-orange-800 dark:text-orange-200 self-start",
  system:
    "bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 self-start text-xs italic",
};

const alignmentStyles = {
  user: "mr-auto",
  assistant: "ml-auto",
  tool: "mr-auto",
  system: "mr-auto",
};

export const Trajectory = ({ trajectory }: { trajectory: TrajectoryData }) => {
  return (
    <div className="flex flex-col space-y-2">
      {trajectory.messages.map((message, index) => {
        const role = message.role as keyof typeof roleStyles;
        const baseStyle = "px-4 py-2 rounded-lg max-w-[80%] text-sm";
        const roleStyle = roleStyles[role] || roleStyles.system; // Default to system style if role is unknown
        const alignStyle = alignmentStyles[role] || alignmentStyles.system;

        return (
          <div
            key={index}
            className={`${baseStyle} ${roleStyle} ${alignStyle}`}
          >
            <div className="text-xs font-medium mb-1 opacity-70 capitalize">
              {message.role}
            </div>
            {message.content && (
              <div className="whitespace-pre-wrap">{message.content}</div>
            )}
            {message.tool_calls && (
              <div className="whitespace-pre-wrap">
                {message.tool_calls.map((call, callIndex) => (
                  <div key={callIndex}>
                    {call.function?.name}({call.function?.arguments || ""})
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
